import { Component, Input, OnInit, inject } from '@angular/core';
import { Office } from 'app/core/models/office.model';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';
import { AuthenticationService } from 'app/core/services/authentication.service';

import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';
import { PhoneNumberComponent } from '../phone-number/phone-number.component';
import { OfficeFaxComponent } from '../office-fax/office-fax.component';
import { ProviderOfficeFaxStatusPipe } from '../../pipes/provider-office-fax-status.pipe';

@Component({
    selector: 'app-office',
    templateUrl: './office.component.html',
    styleUrls: ['./office.component.scss'],
    imports: [CopyToClipboardComponent, PhoneNumberComponent, OfficeFaxComponent, ProviderOfficeFaxStatusPipe]
})
export class OfficeComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() office: Office;
  @Input() providerOffice: ProviderOffice;
  @Input() displayPhoneAndFax = true;
  @Input() allowCopyOfficeName = false;

  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;
  canViewOffice = false;

  ngOnInit() {
    this.canViewOffice = this.authService.isCaptureAdminUser;
  }

}
